export const dashboardUiScale = 0.85;

export const drawerWidth = 221;

export const MAX_IMAGES = 5;

export const TEST_CHAT_PHONE_NUMBER = "+582222222222";
